
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guarantee",
      function () {
        return require("private-next-pages/guarantee/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guarantee"])
      });
    }
  